import React from 'react';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import ConnectorComponent from 'Pages/GMS/ISR/Components/ConnectorComponent';
import ConnectorConfigurations from 'Pages/GMS/ISR/Components/ConnectorConfigurations';
import useConnectorConfigurationUpdater from '../Hooks/useConnectorConfigurationUpdater';

type TConnectorFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
}

const ConnectorField = ({id, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo}: TConnectorFieldProps) => {
    const { updateConnectorConfiguration } = useConnectorConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TConnector) => {
        const connector = selectedItem as TConnector;
        updateConnectorConfiguration(indexInfo, updatedConfig, connector?.data?.belongsToDataModel ?? false);
    };

    return (
        <div id={id}>
            <ConnectorComponent selectedItem={selectedItem} userProjectDataModels={userProjectDataModels} setUserProjectDataModels={setUserProjectDataModels} indexInfo={indexInfo}/>
            <br />
            <ConnectorConfigurations userProjectDataModels={userProjectDataModels} selectedItem={selectedItem} updateFieldDataConfiguration={updateFieldDataConfiguration}/>
        </div>
    );
}

export default ConnectorField;